import React from 'react';
import { Box, Typography } from '@mui/material';
import AgentDailyReport from '../components/reports/AgentDailyReport';

const AgentDailyReportPage = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
        Reporte Diario de Agentes
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Estadísticas detalladas de rendimiento por agente
      </Typography>

      <Box sx={{ mt: 2, flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <AgentDailyReport />
      </Box>
    </Box>
  );
};

export default AgentDailyReportPage;
